import { render, staticRenderFns } from "./DispatchPatternCardEdit.vue?vue&type=template&id=222c4bd3&scoped=true&lang=pug"
import script from "./DispatchPatternCardEdit.vue?vue&type=script&lang=js"
export * from "./DispatchPatternCardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c4bd3",
  null
  
)

export default component.exports